import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../app/hooks';
import { setAuthStatus } from '../features/auth/authSlice';

const PrivateRoute: React.FC<{ children: React.ReactElement }> = ({ children }) => {
  const isAuthenticated = useAppSelector((state) => state.auth.isAuthenticated);
  const token = useAppSelector((state) => state.auth.token);
  const location = useLocation();
  const dispatch = useAppDispatch();

  const [localToken, setLocalToken] = useState<string | null>(() =>
    localStorage.getItem('authorization') // ✅ load it immediately, not inside useEffect
  );

  // only dispatch once if needed
  useEffect(() => {
    if (token && !isAuthenticated && !localToken) {
      dispatch(setAuthStatus());
    }
  }, [dispatch, token, isAuthenticated, localToken]);

  // 🛑 Don't use getGoogleToken in render condition (it's async). Use localToken instead.
  if (!isAuthenticated && !localToken) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  return children;
};

export default PrivateRoute;
